import React, { useEffect, useState } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Link, useHistory } from 'react-router-dom';
import { useCart } from '../../hooks/CartHook';
import api from '../../services/api';
import { getCustomerIdentity } from '../../utils/customerIdentity';

import pixIcon from '../../assets/pix.png';
import whatsappIcon from '../../assets/whatsapp.png';

import './styles.css';

function Checkout() {
    const history = useHistory();
    const { itens: itensCart, observations, totalValue, clearCart, setName } = useCart();
    const [cliente, setCliente] = useState({});
    const [whatsapp, setWhatsapp] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [cep, setCep] = useState('');
    const [cepAddress, setCepAddress] = useState('');
    const [customerIdentity, setCustomerIdentity] = useState({});

    if (itensCart.length === 0) {
        history.push('/');
    }

    const subdominio = window.location.hostname.split('.')[0];

    useEffect(() => {
        api.get(`clientes/${subdominio}`).then(response =>{
            const clienteResponse = response?.data?.[0];
            setCliente(clienteResponse || {});

            try {
                const savedIdentity = getCustomerIdentity() || {};
                setCustomerIdentity(savedIdentity);
                setCnpj(savedIdentity.cnpj || '');
            } catch (error) {
                setCustomerIdentity({});
            }

            if (clienteResponse?.id) {
                localStorage.setItem('cliente_id', String(clienteResponse.id));
            }
        })
    }, [subdominio]);

    function getAuthorizationId() {
        if (cliente?.id) {
            return String(cliente.id);
        }

        const localClienteId = localStorage.getItem('cliente_id');
        if (localClienteId) {
            return localClienteId;
        }

        return '';
    }

    function formatPhone(value) {
        const onlyNumbers = value.replace(/\D/g, '').slice(0, 11);
        if (onlyNumbers.length <= 2) return onlyNumbers;
        if (onlyNumbers.length <= 7) return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(2)}`;
        return `(${onlyNumbers.slice(0, 2)}) ${onlyNumbers.slice(2, 7)}-${onlyNumbers.slice(7)}`;
    }

    function formatCnpj(value) {
        const onlyNumbers = value.replace(/\D/g, '').slice(0, 14);
        if (onlyNumbers.length <= 2) return onlyNumbers;
        if (onlyNumbers.length <= 5) return `${onlyNumbers.slice(0, 2)}.${onlyNumbers.slice(2)}`;
        if (onlyNumbers.length <= 8) return `${onlyNumbers.slice(0, 2)}.${onlyNumbers.slice(2, 5)}.${onlyNumbers.slice(5)}`;
        if (onlyNumbers.length <= 12) return `${onlyNumbers.slice(0, 2)}.${onlyNumbers.slice(2, 5)}.${onlyNumbers.slice(5, 8)}/${onlyNumbers.slice(8)}`;
        return `${onlyNumbers.slice(0, 2)}.${onlyNumbers.slice(2, 5)}.${onlyNumbers.slice(5, 8)}/${onlyNumbers.slice(8, 12)}-${onlyNumbers.slice(12)}`;
    }

    function formatCep(value) {
        const onlyNumbers = value.replace(/\D/g, '').slice(0, 8);
        if (onlyNumbers.length <= 5) return onlyNumbers;
        return `${onlyNumbers.slice(0, 5)}-${onlyNumbers.slice(5)}`;
    }

    async function handleCreateOrderButton() {
        const nome = document.getElementById('name').value;
        const cnpjValue = document.getElementById('cnpj')?.value || '';
        const cepValue = document.getElementById('cep')?.value || '';

        if (!nome || !whatsapp) {
            alert('Preencha os campos para continuar.');
            return;
        }
        if (cliente?.aceitar_cnpj && !cnpjValue) {
            alert('Preencha o CNPJ para continuar.');
            return;
        }
        if (cliente?.aceitar_cep && !cepValue) {
            alert('Preencha o CEP para continuar.');
            return;
        }

        setName(nome);

        const authorizationId = getAuthorizationId();
        if (!authorizationId) {
            alert('Não foi possível identificar a loja. Recarregue a página e tente novamente.');
            return;
        }

        const itens = itensCart.map(item => ({ id: item.id, nome: item.nome, quantidade: item.amount }));

        const body = {
            cliente_id: Number(authorizationId),
            nome: nome,
            empresa: customerIdentity.empresa || nome,
            meio_pagamento: 'PIX',
            whatsapp: whatsapp,
            observacao: observations,
            valor: totalValue,
            itens: itens,
            cnpj: cnpjValue,
            cep: cepValue,
            endereco_cep: cepAddress,
        }

        let response;

        try {
            response = await api.post(`pedidos`, body, {
                headers: {
                    'authorization': authorizationId
                }
            });
        } catch (error) {
            if (error?.response?.status === 401) {
                alert('Sessão da loja não autorizada. Recarregue a página e tente novamente.');
                return;
            }
            alert('Não foi possível finalizar o pedido via Pix. Tente novamente.');
            return;
        }

        if (response.data === "Estoque insuficiente") {
            alert('Algum produto do carrinho está sem estoque suficiente. Tente fazer o pedido novamente.');

            clearCart();

            history.push('/');

            return;
        }
        
        sessionStorage.setItem('last_order_data', JSON.stringify({
            nome,
            totalValue: response.data.valor,
            pedido: response.data,
            pix: response.data.pix,
        }));
        clearCart();
        history.push('/pedido-pix');
    }

    async function handleCreateOrderViaWhatsapp() {
        const nome = document.getElementById('name').value;
        const cnpjValue = document.getElementById('cnpj')?.value || '';
        const cepValue = document.getElementById('cep')?.value || '';

        if (!nome || !whatsapp) {
            alert('Preencha os campos para continuar.');
            return;
        }
        if (cliente?.aceitar_cnpj && !cnpjValue) {
            alert('Preencha o CNPJ para continuar.');
            return;
        }
        if (cliente?.aceitar_cep && !cepValue) {
            alert('Preencha o CEP para continuar.');
            return;
        }

        const authorizationId = getAuthorizationId();
        if (!authorizationId) {
            alert('Não foi possível identificar a loja. Recarregue a página e tente novamente.');
            return;
        }

        const itens = itensCart.map(item => ({ id: item.id, name: item.nome, quantidade: item.amount  }));

        const body = {
            cliente_id: Number(authorizationId),
            nome: nome,
            empresa: customerIdentity.empresa || nome,
            meio_pagamento: 'whatsapp',
            whatsapp: whatsapp,
            observacao: observations,
            valor: totalValue,
            itens: itens,
            cnpj: cnpjValue,
            cep: cepValue,
            endereco_cep: cepAddress,
        }

        let response;
        try {
            response = await api.post(`pedidos`, body, {
                headers: {
                    'authorization': authorizationId,
                    'Content-Type': 'application/json'
                }
            });
        } catch (error) {
            if (error?.response?.status === 401) {
                alert('Sessão da loja não autorizada. Recarregue a página e tente novamente.');
                return;
            }
            alert('Não foi possível finalizar o pedido via WhatsApp. Tente novamente.');
            return;
        }
        

        if (response.data === "Estoque insuficiente") {
            alert('Algum produto do carrinho está sem estoque suficiente. Tente adicionar novamente.');

            clearCart();

            history.push('/');

            return;
        }

        setName(nome);

        let pedido = '';
        itens.forEach((item, index) => {
            pedido += `${item.name} x ${item.quantidade} ${index === (itens.length - 1) ? '.' : ', '}`;
        });

        const deliveryFee = response.data.taxa_entrega || 0;
        const orderTotal = response.data.valor;
        const price = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(orderTotal);
        
        let message = `Olá *${cliente.nome_empresa}*, tenho um novo pedido:\n
        *Nome:* ${nome}
        *Pedido:* ${pedido}
        *Taxa de entrega:* ${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(deliveryFee)}
        *Valor:* ${price}
        ${observations ? `*Obs:* ${observations}\n` : ''}
        Aguardo sua confirmação!`

        message = window.encodeURIComponent(message);
        
        const phoneNumber = String(cliente.whatsapp || '').replace(/\D/g, '');
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
        sessionStorage.setItem('last_whatsapp_order', JSON.stringify({ nome, totalValue: orderTotal, pedido: response.data, whatsappUrl }));
        clearCart();

        history.push('/pedido-whatsapp');
    }

    return (
        <div id="checkout_container">
            <header>
                <Link to="/carrinho">
                    Voltar ao carrinho
                    <FiChevronRight size={16}></FiChevronRight>
                </Link>
            </header>
            <main>
                <h1>Checkout</h1>

                <div className="inputs_container">
                    <input type="text" id="name" placeholder="Nome da empresa" value={customerIdentity.empresa || ''} onChange={event => setCustomerIdentity(identity => ({ ...identity, empresa: event.target.value }))} required />

                    <input 
                        type="tel" 
                        id="whatsapp" 
                        placeholder="Celular"
                        value={whatsapp}
                        onChange={(event) => setWhatsapp(formatPhone(event.target.value))}
                        required 
                    />

                    {!!cliente.aceitar_cnpj || !!customerIdentity.cnpj ? (
                        <input
                            type="text"
                            id="cnpj"
                            placeholder="CNPJ"
                            value={cnpj}
                            onChange={(event) => setCnpj(formatCnpj(event.target.value))}
                            required
                        />
                    ) : null}

                    {!!cliente.aceitar_cep && (
                        <>
                            <input
                                type="text"
                                id="cep"
                                placeholder="CEP de entrega"
                                value={cep}
                                onChange={async (event) => {
                                    const formattedCep = formatCep(event.target.value);
                                    setCep(formattedCep);

                                    const onlyNumbers = formattedCep.replace(/\D/g, '');
                                    if (onlyNumbers.length === 8) {
                                        try {
                                            const response = await fetch(`https://viacep.com.br/ws/${onlyNumbers}/json/`);
                                            const data = await response.json();
                                            if (!data.erro) {
                                                const address = `${data.logradouro}, ${data.bairro}, ${data.localidade} - ${data.uf}`;
                                                setCepAddress(address);
                                            } else {
                                                setCepAddress('');
                                            }
                                        } catch (error) {
                                            setCepAddress('');
                                        }
                                    } else {
                                        setCepAddress('');
                                    }
                                }}
                                required
                            />
                            {cepAddress && <small className="cepAddress">{cepAddress}</small>}
                        </>
                    )}
                </div>

                <div className="buttons_container">
                    {!!cliente.aceitar_pix && (
                        <button 
                            className="pixButton" 
                            onClick={handleCreateOrderButton}
                        >
                            Pedir via Pix
                            <img src={pixIcon} alt="Pix" />
                        </button>
                    )}

                    {!!cliente.aceitar_whatsapp && (
                        <button 
                            className="whatsButton" 
                            onClick={handleCreateOrderViaWhatsapp}
                        >
                            Pedir via Whats
                            <img src={whatsappIcon} alt="Whatsapp" />
                        </button>
                    )}
                </div>

                <div className="order">
                    <h3>Resumo do pedido</h3>

                    <div id="itens_container">
                        {itensCart.map((item, index) => (
                            <div className="item" key={index}>
                                <div className="item_info">
                                    {item.imagem && (
                                        <img src={item.imagem} alt={item.name} />
                                    )}

                                    <div className="item_desc">
                                        <p>{item.nome}</p>
                                        <p>Quantidade: {item.amount}</p> 
                                        <span>Un: {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.preco)}</span><br/>
                                        <span>Total: {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.preco * item.amount)}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="orderTotals">
                        {!!cliente.aceitar_taxa_entrega && (
                            <p><span>Taxa de entrega</span><strong>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(cliente.taxa_entrega || 0))}</strong></p>
                        )}
                        <p className="orderTotal"><span>Valor total do pedido</span><strong>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(totalValue + (cliente.aceitar_taxa_entrega ? Number(cliente.taxa_entrega || 0) : 0))}</strong></p>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default Checkout;
